/* eslint-disable */

/**
 * Do not save scroll position
 */
if ('scrollRestoration' in history) {
  history.scrollRestoration = 'manual';
}

if (window.BX) {
  (function() {

    $(function () {
      /**
       * Ajax default setup
       */
      $.ajaxSetup({
        url: '/local/include/ajax.php',
        type: 'post'
      });

      /**
       * Go To Node
       */
      $.fn.SlideToNode = function (speed, offset) {
        if (!offset) {
          offset = 0;
        }
        $('body,html').animate({
          scrollTop: $(this).offset().top + offset
        }, speed ? speed : 0);
      };

      /**
       * Using GoToNode
       */
      $(document).on('click', '.js-goto[data-target]', function (e) {
        var targetObj = $($(this).data('target'));
        if (targetObj.length)
          targetObj.SlideToNode(500);
        e.preventDefault();
      });

      /**
       * Follow url by data-attr
       */
      $(document).on('click', '.js-follow-url', function (e) {
        e.preventDefault();
        if ($(this).data('follow-url')) {
          window.location = $(this).data('follow-url');
        }
        //window.open(href, '_blank', 'width=238,height=210,resizable=no,toolbar=no,menubar=no,location=no,status=no');
      });

      /**
       * Close BX waiting block if form is not valid
       */
      window.Parsley.on('form:error', function () {
        if (this.$element.data('parsley-disabled-btn-submit'))
          $(this.$element.data('parsley-disabled-btn-submit')).removeAttr('disabled');
        BX.closeWait();
      });

      /**
       * Unset validation form by data-attr
       */
      window.Parsley.on('form:validated', function (formInstance) {
        if (this.$element.data('parsley-novalidate')) {
          formInstance.validationResult = true;
          formInstance.destroy();
        }
      });

      /**
       * Registration form popup
       */
      $(document).on('click', '#popup-reg .js-reg-promo-open', function (e) {
        e.preventDefault();
        var $btn = $(this),
          $target = $('#popup-reg .js-reg-promo-block');
        $btn.parent().fadeOut();
        $target.toggle(300);
      });

      /**
       * Personal forms
       * Send invitation to friend by email .js-form__send_invitation
       * Activate certificate .js-form__activate_certificate
       */
      $(document).on('submit', '.js-form__send_invitation, .js-form__activate_certificate', function (e) {
        e.preventDefault();
        var $form = $(this),
          $btn = $form.find('button:last');
        $.ajax({
          url: $form.data('ajax-action'),
          data: $form.serialize(),
          method: 'POST',
          dataType: 'json',
          beforeSend: function () {
            $form.parent().find('.js-message-success, .js-message-error').empty();
            $btn.attr('disabled', true);
          },
          complete: function () {
            $btn.attr('disabled', false);
          }
        }).done(function (data) {
          if (data.success) {
            $form.parent().find('.js-message-success').html(data.success);
          }
          else if (data.error) {
            $form.parent().find('.js-message-error').html(data.error);
          }
          else if (data.needAuth) {
            fastPopupOpen('popup-login');
          }
        });
      });

      /**
       * Switch blocks
       */
      $(document).on('click', '.js-toggle-click', function (e) {
        e.preventDefault();
        $(this).parent().find('.js-toggle')
          .filter(':visible').toggle()
          .siblings('.js-toggle').toggle();
      });

      /**
       * Adding offer to basket
       */
      $(document).on('click', '.js-btn-add2basket', function (e) {
        e.preventDefault();
        var
          $btn = $(this),
          offersId = [];

        if ($btn.data('offer-id') != undefined) {
          offersId.push($btn.data('offer-id'))
        } else {
          $('#js-product-vars').find('input:checked').each(function() {//Собираем в массив id всех выделенных предложений
            offersId.push($(this).val());
          });
        }
        if (!offersId.length) {
          $('#popup-basket-error .js-message-content').html(BX.message('JS_SELECT_SIZE_TO_ADD_TO_CART')); // 'Пожалуйста, выберите размер товара для добавления в корзину'
          $('#popup-basket-error .js-message-title').html(BX.message('JS_CHOOSE_CLOTHING_SIZE')); // 'Выберите размер одежды'
          fastPopupOpen("popup-basket-error", function () {
            $('#js-product-vars').SlideToNode(500)
          });
          return;
        }
        $.ajax({
          data: {
            'mode': 'basketAdd',
            'offersId': offersId
          },
          beforeSend: function () {
            $btn.attr('disabled', true);
          },
          complete: function () {
            $btn.attr('disabled', false);
          },
          dataType: 'json',
          success: function (answer) {
            if (answer.result) {
              if ($btn.data('redirect'))
                window.location.href = $btn.data('redirect');
              else {
                fastPopupOpen("popup-basket-add");

                // Facebook pixel
                if (typeof fbq != 'undefined') {
                  fbq('track', 'AddToCart');
                }

                /** Yandex metrika */
                window.App.Analytics.reachGoal('addToCart');

                /**
                 * Ecommerce
                 * Event: add to basket
                 */
                if (typeof answer.items != 'undefined') {
                  answer.items.forEach(function(item) {
                    window.ecommerce.events.basketAdd({
                      'id': item.PRODUCT_ID,
                      'name': item.NAME,
                      'price': item.PRICE,
                      'quantity': item.QUANTITY,
                      'category': item.CATEGORY,
                      'variant': item.VARIANT
                    });
                  });
                }
              }
              $('#js-header-cart').trigger('custom.updateTopBasket');
            }
            else {
              $('#popup-basket-error .js-message-content').html(BX.message('JS_ERROR_ADDING_PRODUCT')); // 'Ошибка добавления товара'
              $('#popup-basket-error .js-message-content').html(answer.message || BX.message('JS_PRODUCT_CANNOT_BE_ADDED_TO_CART')); // 'Произошла ошибка, товар не может быть добавлен в корзину'
              fastPopupOpen("popup-basket-error");
            }
          }
        });
        if ($('#js-catalog-delivery-form').length) {
          $.ajax({
            url: window.location.href,
            type: "post",
            data: $('#js-catalog-delivery-form').serialize(),
            complete: function () {
              window.App.oldModules.Spoiler.initAll();
              window.App.update();
            },
            success: function (r) {
              $('#js-catalog-delivery-form').replaceWith($(r).find('#js-catalog-delivery-form'));
            }
          });
        }

      });


      /**
       * Adding offer to wishlist
       */
      $(document).on('click', '.js-btn-add2wishlist', function (e) {
        e.preventDefault();
        var
          $btn = $(this),
          offersId = [];

        if ($btn.data('offer-id') != undefined) {
          offersId.push($btn.data('offer-id'))
        } else {
          $('#js-product-vars').find('input:checked').each(function() {
            offersId.push($(this).val());
          });
        }

        if (!offersId.length) {
          $('#popup-basket-error .js-message-content').html(BX.message('JS_SELECT_SIZE_TO_ADD_TO_WISHLIST')); // 'Пожалуйста, выберите размер, чтобы отложить его в Ваш список желаний'
          $('#popup-basket-error .js-message-title').html(BX.message('JS_CHOOSE_CLOTHING_SIZE')); // 'Выберите размер одежды'
          fastPopupOpen("popup-basket-error", function () {
            $('#js-product-vars').SlideToNode(500)
          });
          return;
        }
        $.ajax({
          data: {
            'mode': 'wishlistAdd',
            'offersId': offersId
          },
          beforeSend: function () {
            $btn.attr('disabled', true);
          },
          complete: function () {
            $btn.attr('disabled', false);
          },
          dataType: 'json',
          success: function (answer) {
            if (answer.result) {
              fastPopupOpen("popup-wishlist-add");

              /** YM and GA */
              window.App.Analytics.reachGoal('addToWishList', 'addToWishList');
            }
            else {
              $('#popup-basket-error .js-message-title').html(BX.message('JS_ERROR_ADDING_PRODUCT')); // 'Ошибка добавления товара'
              $('#popup-basket-error .js-message-content').html(BX.message('JS_ITEM_CANNOT_BE_DELAYED')); // 'Произошла ошибка, товар не может быть отложен'
            }
          }
        });
      });

      /**
       * Update top basket handler
       */
      $(document).on('custom.updateTopBasket', basketTopUpdate);

      /**
       * Close popup handler
       * Clear if #message popup was closed
       */
      $(document).on('mfpClose', function (e) {
        if ($('.popup:visible').attr('id') == 'message') {
          $('#js-modalmsg-title, #js-modalmsg-text').empty();
        }
      });

      /**
       * Analytics for popups
       */
      $('.js-popup-open').on('mfpOpen', function (e, params) {
        if (typeof $.magnificPopup.instance.currItem.src != 'undefined') {
          switch ($.magnificPopup.instance.currItem.src) {
            case '#popup-account-pay':
              window.App.Analytics.reachGoal({
                'ya': 'RefillBalanceClicked',
                'ga': {
                  'name': 'RefillBalance',
                  'action': 'Clicked',
                }
              });
              break;
          }
        }
      });

      /**
       * Catalog sorting
       */
      $(document).on('click', '.js-sort__item', function (e) {
        var link = $(this).attr('href');
        var text = $('.js-lc-catalog-search-form').find('input[name="q"]').val();

        App.oldModules.Preloader.show();
        BX.ajax({
          url: link,
          method: 'POST',
          data: {'AJAX': 'Y', 'q': text},
          onsuccess: function (data) {
            window.App.oldModules.Preloader.hide();
            $('#js-lc-pr-list').html(data);
            window.App.initModules();
            window.App.update();
          },
          onfailure: function () {
            window.App.oldModules.Preloader.hide();
            alert(BX.message('JS_REQUEST_ERROR_OCCURRED')); // 'Произошла ошибка запроса'
          }
        });
        return false;
      });

      /**
       * Обработка события подгрузки элементов в каталог.
       */
      $('#mainCatalog').on('onCatalogContentInsertAfter', event => {
        App.oldModules.Popup.initAll(); // Актуализируем работу popup для подгруженных элементов

        let ecommerceData = event.detail;

        // Вызываем событие ecommerce открытие страницы каталога
        window.ecommerce.events.productItemsDisplay(ecommerceData.items, ecommercePageData.page);

        // Добавляем подгруженные элементы в ecommerceData.items, чтобы дальнейшие события ecommerce отрабатывали на этих элементах
        for (let key in ecommerceData.items) {
            ecommercePageData.items[key] = ecommerceData.items[key];
        }
      });

      /**
       * Form validation event
       */
      if (typeof window.Parsley !== 'undefined') {
        window.Parsley.on('form:error', function () {
          if (this.$element.find('input[type=hidden][name=bxajaxid]').length == 1)
            BX.closeWait();
        });
      }

      /**
       * Page close event handler
       */
      $(document).on('mouseleave', function (e) {
        var windowPosition = {
          top: window.pageYOffset,
          left: window.pageXOffset,
          right: window.pageXOffset + document.documentElement.clientWidth,
          bottom: window.pageYOffset + document.documentElement.clientHeight
        };
        if (windowPosition.top - e.pageY >= 0) {
          $(document).trigger('pageClose');
        }
      });

      /**
       * Start subscription on push notifications
       */
      if (typeof oSpP == 'object') {
        var fireNotification = false,
          fireNotificationCategory = '';
        if (
          window.location.href.indexOf('/land/b2b') != -1 ||
          window.location.href.indexOf('/land/b2c') != -1
        ) {
          fireNotification = true;
          fireNotificationCategory = 'NewsBrand';
        }
        else if (
          window.location.href.indexOf('/personal') != -1
        ) {
          fireNotificationCategory = 'Personal';
          fireNotification = true;
        }
        if (fireNotification) {
          if (typeof oSpP.startSubscription == 'function') {
            setTimeout(function () {
              oSpP.startSubscription();
              oSpP.push('Category', fireNotificationCategory);
            }, 5000);
          }
        }
      }
    });

    /**
     * Ecommerce
     */
    window.Ecommerce = function Ecommerce() {

      const _this = this;

      this.showedBanners = {};

      this.init = function () {

        // Init dom event handlers
        this.initHandlers();
        this.onScroll();

        if (typeof ecommercePageData == 'undefined')
          return;

        // Page display events
        switch (ecommercePageData.type) {
          // catalog's items page
          case 'catalogList':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.productItemsDisplay(
              items,
              ecommercePageData['page']
            );
            break;

          // catalog detail page
          case 'catalogDetail':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.productDetailDisplay(
              items,
              ecommercePageData['page']
            );
            break;

          // checkout: step 1 - basket page
          case 'checkoutStep1':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.checkoutStep(
              items,
              {
                type: 'Корзина',
                step: '1',
                option: 'display'
              }
            );
            break;

          // checkout: step 2 - order page
          case 'checkoutStep2':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.checkoutStep(
              items,
              {
                type: 'Оформление заказа',
                step: '2',
                option: 'display'
              }
            );
            break;

          // checkout: step 3 - confirm order page
          case 'checkoutStep3':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.checkoutStep(
              items,
              {
                type: 'Оформление заказа',
                step: '3',
                option: 'confirm'
              }
            );
            break;

          // order payed
          case 'transaction':
            var items = [];
            for (var i in ecommercePageData['items']) {
              items.push(ecommercePageData['items'][i]);
            }
            this.events.transaction(
              {
                id: ecommercePageData.order['id'],
                price: ecommercePageData.order['price'],
                fullPrice: ecommercePageData.order['fullPrice'],
                deliveryPrice: ecommercePageData.order['deliveryPrice'],
                coupon: ecommercePageData.order['coupon'],
                points: ecommercePageData.order['applyingPoints'],
                affiliation: ecommercePageData.order['affiliation']
              },
              items
            );
            break;
        }
      };

      this.initHandlers = function () {
        // Event: catalog's item clicked
        $(document).on('click', '[data-ecommerce-item]', function () {
          var itemId = $(this).data('ecommerce-item');
          if (
            itemId &&
            typeof ecommercePageData != 'undefined' &&
            typeof ecommercePageData['items'][itemId] != 'undefined'
          ) {
            _this.events.productItemClick(
              ecommercePageData['items'][itemId],
              ecommercePageData['page']
            );
          }
        });

        // Event: catalog's item clicked
        $(document).on('click', '[data-ecommerce-banner] a', function () {
          const
            banner = $(this).closest('[data-ecommerce-banner]'),
            bannerId = banner.data('ecommerce-banner'),
            position = banner.data('banner-position'),
            name = banner.data('banner-name');

          if (bannerId) {
            _this.events.bannerClick(bannerId, position, name);
          }
        });

        $(window).on('scroll', function (e) {
          _this.onScroll();
        });
      };

      this.onScroll = function() {
        let banners = $('[data-ecommerce-banner]');
        const
          windowTop = $(window).scrollTop(),
          windowHeight = $(window).height();

        for (let i = 0; i < banners.length; i++) {
          let banner = banners[i];
          const
            bannerId = $(banner).data('ecommerce-banner'),
            position = $(banner).data('banner-position'),
            name = $(banner).data('banner-name');

          if (_this.showedBanners[bannerId]) {
            continue;
          }

          if (windowTop + windowHeight >= $(banner).offset().top){
            _this.events.bannerShow(bannerId, position, name);
            _this.showedBanners[bannerId] = true;
          }
        }
      };

      this.events = {

        productItemsDisplay: function (items, page) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e1',
            'ecommerce_funnel': 'none',
            'ecommerce_step': 'productImpression',
            'ecommerce_param': page,
            'ecommerce': {
              'impressions': items
            }
          });
        },

        productItemClick: function (item, page) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e2',
            'ecommerce_funnel': 'none',
            'ecommerce_step': 'productClick',
            'ecommerce_param': page,
            'ecommerce': {
              'click': {
                'actionField': {'list' : page},
                'products': [item]
              }
            }
          });
        },

        productDetailDisplay: function (items) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e3',
            'ecommerce_funnel': 'none',
            'ecommerce_step': 'productDetail',
            'ecommerce_param': 'none',
            'ecommerce': {
              'detail': {
                'products': items
              }
            }
          });
        },

        basketAdd: function (item) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e4',
            'ecommerce_funnel': 'Корзина',
            'ecommerce_step': 'addToCart',
            'ecommerce_param': 'none',
            'ecommerce': {
              'add': {
                'products': [item]
              }
            }
          });
        },

        basketRemove: function (items) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e5',
            'ecommerce_funnel': 'Корзина',
            'ecommerce_step': 'removeFromCart',
            'ecommerce_param': 'none',
            'ecommerce': {
              'remove': {
                'products': items
              }
            }
          });
        },

        checkoutStep: function (items, parameters) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e6',
            'ecommerce_funnel': parameters.type,
            'ecommerce_step': 'checkout1',
            'ecommerce_param': 'none',
            'ecommerce': {
              'checkout': {
                'actionField': {
                  'step': parameters.step,
                  'option': parameters.option
                },
                'products': items
              }
            }
          });
        },

        transaction: function (order, items) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-nXX-e7',
            'ecommerce_funnel': 'Оформление заказа',
            'ecommerce_step': 'transaction',
            'ecommerce_param': order.id,
            'ecommerce': {
              'purchase': {
                'actionField': {
                  'id': order.id,
                  'revenue': order.fullPrice,
                  'shipping': order.deliveryPrice,
                  'coupon': order.coupon,
                  'points': order.points,
                  'affiliation': order.affiliation
                },
                'products': items
              }
            }
          });
        },

        bannerShow: function (id, position, name) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-n02-e2',
            'ecommerce_step':'promoView',
            'ecommerce_param':'none',
            'ecommerce': {
              'promoView': {
                'promotions': [{
                  'name': name,          // Название баннера
                  'id': id,              // ID баннера или уникальный идентификатор
                  'position': position   // Позиция баннера (тип баннера)
                }]
              }
            }
          });
        },

        bannerClick: function (id, position, name) {
          _this.send({
            'event': 'addEcommerce',
            'event_id': 'd-n02-e3',
            'ecommerce_step':'promoClick',
            'ecommerce_param':'none',
            'ecommerce': {
              'promoClick': {
                'promotions': [{
                  'name': name,          // Название баннера
                  'id': id,              // ID баннера или уникальный идентификатор
                  'position': position   // Позиция баннера (тип баннера)
                }]
              }
            }
          });
        }
      };

      this.send = function (data) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(data);
        _this.log(data);
      };

      this.log = function (data) {
        $.ajax({
          url: '/local/ajax/log_ecommerce.php',
          data: {
            ecommerce_data: data,
            page_url: location.href
          },
          method: 'POST',
          dataType: 'json'
        });
      };
    };
    $(function () {
      window.ecommerce = new Ecommerce();
      window.ecommerce.init();
    });

    /**
     * Phone validation
     */
    window.PhoneValidation = function PhoneValidation() {
      const _this = this;

      this.init = () => {
        if (!window.PhoneNumberData) {
          return;
        }
        window.PhoneNumberData.forEach(item => {
          var phoneNumberInput = new BX.PhoneNumber.Input({
            node: BX(item.fieldId),
            flagSize: 16,
            forceLeadingPlus: false,
            defaultCountry: item.langId || 'ru',
            onChange: function(e) {
              if (e.value.length > 0 && e.value[0] !== '+') {
                BX(item.fieldId).value = '+' + e.value;
              }
            },
          });
        });

      },
        this.reInit = () => {
          _this.init();
        }
    };
    $(function() {
      window.phoneValidation = new PhoneValidation();
      window.phoneValidation.init();
    });

    /**
     * BX events
     */
    BX.ready(function () {

      /**
       * Update top basket handler
       */
      BX.addCustomEvent('OnUpdateTopBasket', basketTopUpdate);

      /**
       * Bitrix Composite Technology
       */
      if (window.frameCacheVars !== undefined) {
        var onFrameDataReceivedHandler = function() {
          console.log('composite: frame data received');
          $(function() {
            window.App.initModules();
            window.App.update();
          });
        };
        var onFrameDataRequestFail = function() {
          console.log("composite: request error");
        };
        BX.addCustomEvent("onFrameDataReceived", onFrameDataReceivedHandler());
        BX.addCustomEvent("onFrameDataRequestFail", onFrameDataRequestFail());
      }

    });

    /**
     * Update top basket function
     */
    window.basketTopUpdate = function () {
      $.get(window.location.href, {mode: 'reload', ncc: 'Y'}, function (content) {
        $('#js-header-cart').replaceWith(
          $(content).find('#js-header-cart')
        );
      });
    };

    /**
     * Fast popup open
     */
    window.fastPopupOpen = function fastPopupOpen(popupId, callback) {
      if (popupId.indexOf('#') == -1)
        popupId = '#' + popupId;

      var options = {items: {src: popupId, type: "inline"}};
      if (callback !== undefined && typeof callback == 'function') {
        options = $.extend(options, {
          callbacks: {
            close: callback
          }
        });
      }

      window.App.oldModules.Popup.open(options);
    }

    /**
     * Open popup with any content
     *
     * @param body
     * @param title
     */
    window.showInPopup = function showInPopup(body, title) {
      if (!body)
        return;

      title = title || '';
      $('#js-modalmsg-title').html(title);
      $('#js-modalmsg-text').html(body);
      fastPopupOpen('message');
    }

    /***
     number - исходное число
     decimals - количество знаков после разделителя
     dec_point - символ разделителя
     thousands_sep - разделитель тысячных
     ***/
    window.number_format = function number_format(number, decimals, dec_point, thousands_sep) {
      number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
      var n = !isFinite(+number) ? 0 : +number,
        prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
        sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
        dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
        s = '',
        toFixedFix = function (n, prec) {
          var k = Math.pow(10, prec);
          return '' + (Math.round(n * k) / k)
            .toFixed(prec);
        };
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
        .split('.');
      if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
      }
      if ((s[1] || '')
        .length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1)
          .join('0');
      }
      return s.join(dec);
    }

    /**
     * Помещает в буфер указанный текст.
     * Дополнительно может быть передан элемент, который будет показа
     * @param text
     * @param element
     */
    window.copyToClipboard = function(text, element = null) {
      if (!text || !navigator.clipboard) {
        return;
      }

      navigator.clipboard.writeText(text)
        .then(() => {
          if (element) {
            element.show('slow');
            setTimeout(() => {
              element.hide('slow');
            }, 5000);
          }
        })
        .catch(err => {
        });
    }
  })();
}

export default {};
